var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-mask',{attrs:{"mask":"###-###-####","value":_vm.value,"masked":true,"type":"tel","autocomplete":"off","name":"newPhone"},on:{"input":_vm.inputOccurred}})}
var staticRenderFns = []

export { render, staticRenderFns }